import { render, staticRenderFns } from "./pdf-notes.html?vue&type=template&id=795d5380&scoped=true&external"
import script from "./pdf-notes.js?vue&type=script&lang=js&external"
export * from "./pdf-notes.js?vue&type=script&lang=js&external"
import style0 from "./pdf-notes.scss?vue&type=style&index=0&id=795d5380&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d5380",
  null
  
)

export default component.exports